/* Legacy code - ignore this errors */
/* eslint class-methods-use-this: 0 */
import React from 'react';
import Flexbox from 'flexbox-react';
import { Tab, Tabs, Button, Classes, Intent } from '@blueprintjs/core';
import { inject, observer } from 'mobx-react';
import SocialAuthButton from './SocialAuthButton';
import classNames from 'classnames';
import _ from 'lodash';

@inject('AuthStore', 'ToastStore')
@observer
export default class SignInNew extends React.Component {
  constructor(props) {
    super(props);

    this.state = { isSubmitting: false, isBlurred: [] };
  }

  toggleLoading = () => {
    this.setState({
      isSubmitting: !this.state.isSubmitting,
    });
  };

  handleSubmit(e) {
    e.preventDefault();
    if (this.props.AuthStore.signInFormValid) {
      this.toggleLoading();
      this.setState({ isBlurred: [] });
      this.props.AuthStore.createSignIn()
        .then(() => {
          this.toggleLoading();
        })
        .catch(() => {
          this.toggleLoading();
        });
    } else {
      this.setState({
        isBlurred: ['email', 'password'],
      });
    }
  }

  handleInputChange(e) {
    this.props.AuthStore.updateNewSignIn(e.target.value, e.target.name);
  }

  handleBlurChange(e) {
    if (!_.includes(this.state.isBlurred, e.target.name)) {
      const newBlurState = this.state.isBlurred;
      newBlurState.push(e.target.name);
      this.setState({ isBlurred: newBlurState });
    }
  }

  renderErrors(field) {
    if (_.includes(this.state.isBlurred, field) && !this.props.AuthStore.newSignIn[`${field}Valid`]) {
      return <div className="bp3-form-helper-text">{this.props.AuthStore.newSignIn[`${field}Error`]}</div>;
    }
    return undefined;
  }

  renderEmailForm() {
    return (
      <form onSubmit={this.handleSubmit.bind(this)}>
        <Flexbox flexDirection="row" flexGrow={1} className="push-20-t">
          <Flexbox
            flexGrow={1}
            className={
              _.includes(this.state.isBlurred, 'email') && !this.props.AuthStore.newSignIn.emailValid
                ? classNames('bp3-form-group bp3-intent-danger')
                : classNames('bp3-form-group')
            }
          >
            <label className="bp3-label" htmlFor="email">
              {I18n.t('js.email')}
              <span className="bp3-text-muted push-5-l">({I18n.t('js.required')})</span>
            </label>
            <Flexbox flexGrow={1} className="bp3-form-content" flexDirection="column">
              <Flexbox
                flexGrow={1}
                className={
                  _.includes(this.state.isBlurred, 'email') && !this.props.AuthStore.newSignIn.emailValid
                    ? classNames('bp3-input-group bp3-intent-danger')
                    : classNames('bp3-input-group')
                }
              >
                <input
                  className="bp3-input bp3-fill"
                  type="text"
                  placeholder={I18n.t('js.someone_example_com')}
                  name="email"
                  value={this.props.AuthStore.newSignIn.email}
                  onChange={this.handleInputChange.bind(this)}
                  onBlur={this.handleBlurChange.bind(this)}
                  dir="auto"
                />
              </Flexbox>
              {this.renderErrors('email')}
            </Flexbox>
          </Flexbox>
        </Flexbox>
        <Flexbox flexDirection="row" flexGrow={1}>
          <Flexbox
            flexGrow={1}
            className={
              _.includes(this.state.isBlurred, 'password') && !this.props.AuthStore.newSignIn.passwordValid
                ? classNames('bp3-form-group bp3-intent-danger')
                : classNames('bp3-form-group')
            }
          >
            <label className="bp3-label" htmlFor="password">
              {I18n.t('js.password')}
              <span className="bp3-text-muted push-5-l">({I18n.t('js.required')})</span>
            </label>
            <Flexbox flexGrow={1} className="bp3-form-content" flexDirection="column">
              <Flexbox
                flexGrow={1}
                className={
                  _.includes(this.state.isBlurred, 'password') && !this.props.AuthStore.newSignIn.passwordValid
                    ? classNames('bp3-input-group bp3-intent-danger')
                    : classNames('bp3-input-group')
                }
              >
                <input
                  autoComplete="off"
                  className="bp3-input bp3-fill"
                  type="password"
                  placeholder={I18n.t('js.password')}
                  name="password"
                  value={this.props.AuthStore.newSignIn.password}
                  onChange={this.handleInputChange.bind(this)}
                  onBlur={this.handleBlurChange.bind(this)}
                  dir="auto"
                />
              </Flexbox>
              {this.renderErrors('password')}
            </Flexbox>
          </Flexbox>
        </Flexbox>
        <Flexbox flexDirection="row" flexGrow={1}>
          <Button
            intent={Intent.PRIMARY}
            type="submit"
            className="bp3-fill bp3-large"
            text={I18n.t('js.sign_in')}
            loading={this.state.isSubmitting}
          />
        </Flexbox>
      </form>
    );
  }

  renderConnectedAccounts() {
    return (
      <Flexbox flexDirection="column">
        <SocialAuthButton
          text={I18n.t('js.sign_in_with_google')}
          connection="google-oauth2"
          image="https://res.cloudinary.com/dkctgehrc/image/upload/v1497899678/google_logo_transparent_whvdyb.png"
        />
        <Button
          type="button"
          intent={Intent.PRIMARY}
          className="bp3-fill bp3-large bp3-icon-envelope"
          text={I18n.t('js.sign_in_with_email')}
          loading={this.state.isSubmitting}
          onClick={() => this.props.AuthStore.updateActiveTab('email')}
        />
      </Flexbox>
    );
  }

  renderSSO() {
    return (
      <div className="bp3-callout bp3-intent-primary bp3-icon-info-sign">
        <h4 className={`${Classes.HEADING} bp3-callout-title`}>{I18n.t('js.sso_active_directory')}</h4>
        <p>{I18n.t('js.single_sign_in_supported')}</p>
      </div>
    );
  }

  render() {
    return (
      <div>
        <Tabs
          selectedTabId={this.props.AuthStore.activeTab}
          defaultSelectedTabId="social"
          onChange={tab => this.props.AuthStore.updateActiveTab(tab)}
        >
          <Tab id="email" title={I18n.t('js.email')} panel={this.renderEmailForm()} />
          <Tab id="social" title={I18n.t('js.social')} panel={this.renderConnectedAccounts()} />
          {/* <Tab
            id="sso"
            title={I18n.t('js.sso_active_directory')}
            panel={this.renderSSO()}
          /> */}
        </Tabs>
      </div>
    );
  }
}
